<template>
  <div>
    <el-dialog v-dialogDrag top="5vh" custom-class="rtc-private-video-dialog" :title="title" :width="width"
      :visible.sync="showRoom" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="onQuit">
      <div class="rtc-private-video">
        <div v-show="isVideo" class="rtc-video-box">
          <div class="rtc-video-friend" v-loading="!isChating" element-loading-text="等待对方接听..."
            element-loading-background="rgba(0, 0, 0, 0.1)">
            <head-image class="friend-head-image" :id="friend.id" :size="80" :name="friend.nickName"
              :url="friend.headImage" :isShowUserInfo="false" radius="0">
            </head-image>
            <video ref="remoteVideo" autoplay=""></video>
          </div>
          <div class="rtc-video-mine">
            <video ref="localVideo" autoplay=""></video>
          </div>
        </div>
        <div v-show="!isVideo" class="rtc-voice-box" v-loading="!isChating" element-loading-text="等待对方接听..."
          element-loading-background="rgba(0, 0, 0, 0.1)">
          <head-image class="friend-head-image" :id="friend.id" :size="200" :name="friend.nickName"
            :url="friend.headImage" :isShowUserInfo="false">
            <div class="rtc-voice-name">{{ friend.nickName }}</div>
          </head-image>
        </div>
        <div class="rtc-control-bar">
          <div title="取消" class="icon iconfont icon-phone-reject reject" style="color: red;" @click="onQuit()"></div>
        </div>
      </div>
    </el-dialog>
    <rtc-private-acceptor v-if="showIncomingAcceptor" ref="acceptor" :friend="friend" :mode="mode"
      :countdown="incomingCountdown" @accept="onAccept" @reject="onReject"></rtc-private-acceptor>
    <rtc-call-starting :visible="callStartVisible" :state="callStartState" :mode="mode"
      :remaining-seconds="callStartRemainingSeconds" :detail="callStartDetail"
      @cancel="cancelCallStartRetry"></rtc-call-starting>
  </div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RtcPrivateAcceptor from './RtcPrivateAcceptor.vue';
import RtcCallStarting from './RtcCallStarting.vue';
import ImWebRtc from '@/api/webrtc';
import ImCamera from '@/api/camera';
import RtcPrivateApi from '@/api/rtcPrivateApi'
import {
  createCallStartRetry,
  generateClientCallId,
  resolveCallStartRetryTimeoutMs
} from '@/api/callStartRetry';
import {
  CALL_SOUND_ENABLED_STORAGE_KEY,
  CALL_SOUND_STORAGE_KEY,
  getCallSoundOption
} from '@/config/callSoundOptions';

export default {
  name: 'rtcPrivateVideo',
  components: {
    HeadImage,
    RtcPrivateAcceptor,
    RtcCallStarting
  },
  data() {
    return {
      camera: new ImCamera(), // 摄像头和麦克风
      webrtc: new ImWebRtc(), // webrtc相关
      API: new RtcPrivateApi(), // API
      audio: new Audio(), // 呼叫音频
      showRoom: false,
      friend: {},
      isHost: false, // 是否发起人
      state: "CLOSE", // CLOSE:关闭  WAITING:等待呼叫或接听 CHATING:聊天中  ERROR:出现异常
      mode: 'video', // 模式 video:视频聊 voice:语音聊天
      localStream: null, // 本地视频流
      remoteStream: null, // 对方视频流
      videoTime: 0,
      videoTimer: null,
      heartbeatTimer: null,
      localCandidates: [],
      pendingRemoteCandidates: [],
      showIncomingAcceptor: false,
      incomingCountdown: 90,
      incomingCountdownTimer: null,
      incomingDeadlineAt: 0,
      waitTimer: null,
      beforeUnloadHandler: null,
      showRoomTimer: null,
      callStartController: null,
      callStartCloseTimer: null,
      clientCallId: '',
      callStartVisible: false,
      callStartState: 'retrying',
      callStartRemainingSeconds: 30,
      callStartDetail: '',
      CALL_UI_REVEAL_DELAY_MS: 1500,
    }
  },
  methods: {
    resolveCallTimeoutSeconds(message = null) {
      const messageTimeout = Number(message && message.callTimeoutSeconds);
      const configTimeout = Number(this.configStore && this.configStore.webrtc &&
        this.configStore.webrtc.callTimeoutSeconds);
      const timeout = messageTimeout > 0 ? messageTimeout : configTimeout;
      return Number.isFinite(timeout) && timeout > 0 ? Math.floor(timeout) : 90;
    },
    startIncomingWaitTimer(message, ringingData = null) {
      this.clearIncomingWaitTimer();
      const deadline = Number(ringingData && ringingData.expiresAt) || Number(message && message.expiresAt);
      const now = Date.now();
      this.incomingDeadlineAt = deadline > now
        ? deadline
        : now + this.resolveCallTimeoutSeconds(message) * 1000;
      const waitMillis = Math.max(0, this.incomingDeadlineAt - now);
      this.updateIncomingCountdown();
      this.incomingCountdownTimer = setInterval(() => {
        this.updateIncomingCountdown();
      }, 1000);
      this.waitTimer = setTimeout(() => {
        this.incomingCountdown = 0;
        this.$message.error("您未接听");
        this.close();
      }, Math.max(0, waitMillis));
    },
    updateIncomingCountdown() {
      if (this.incomingDeadlineAt <= 0) {
        return;
      }
      this.incomingCountdown = Math.max(0,
        Math.ceil((this.incomingDeadlineAt - Date.now()) / 1000));
    },
    clearIncomingWaitTimer() {
      if (this.waitTimer) {
        clearTimeout(this.waitTimer);
        this.waitTimer = null;
      }
      if (this.incomingCountdownTimer) {
        clearInterval(this.incomingCountdownTimer);
        this.incomingCountdownTimer = null;
      }
      this.incomingDeadlineAt = 0;
    },
    clearShowRoomTimer() {
      if (this.showRoomTimer) {
        clearTimeout(this.showRoomTimer);
        this.showRoomTimer = null;
      }
    },
    scheduleShowRoom() {
      this.clearShowRoomTimer();
      this.showRoomTimer = setTimeout(() => {
        this.showRoomTimer = null;
        if (this.state !== 'CLOSE') {
          this.showRoom = true;
          this.$nextTick(() => {
            this.attachMediaStreamsToRefs();
          });
        }
      }, this.CALL_UI_REVEAL_DELAY_MS);
    },
    attachMediaStreamsToRefs() {
      if (this.$refs.localVideo && this.localStream) {
        this.$refs.localVideo.srcObject = this.localStream;
        this.$refs.localVideo.muted = true;
      }
      if (this.$refs.remoteVideo && this.remoteStream) {
        this.$refs.remoteVideo.srcObject = this.remoteStream;
      }
    },
    buildIncomingFriend(msg) {
      const localFriend = this.friendStore && this.friendStore.findFriend ? this.friendStore.findFriend(msg.sendId) : null;
      if (localFriend) {
        return {
          ...localFriend
        };
      }
      return {
        id: msg.sendId,
        nickName: `用户${msg.sendId}`,
        headImage: ""
      };
    },
    flushLocalCandidates() {
      if (!this.friend.id || !this.localCandidates.length) {
        return;
      }
      this.localCandidates.forEach((candidate) => {
        this.API.sendCandidate(this.friend.id, candidate);
      });
      this.localCandidates = [];
    },
    flushPendingRemoteCandidates() {
      if (!this.webrtc.peerConnection || !this.webrtc.peerConnection.remoteDescription) {
        return Promise.resolve();
      }
      if (!this.pendingRemoteCandidates.length) {
        return Promise.resolve();
      }
      const queued = [...this.pendingRemoteCandidates];
      this.pendingRemoteCandidates = [];
      return queued.reduce((promise, candidate) => {
        return promise.then(() => this.webrtc.addIceCandidate(candidate).catch((error) => {
          console.error("缓存ICE候选添加失败:", error);
        }));
      }, Promise.resolve());
    },
    open(rtcInfo) {
      this.mode = rtcInfo.mode;
      this.isHost = rtcInfo.isHost;
      this.friend = rtcInfo.friend;
      this.clientCallId = generateClientCallId();
      this.resetCallStartView();
      this.state = "WAITING";
      this.scheduleShowRoom();
      if (this.isHost) {
        this.onCall();
      }
    },
    initAudio() {
      const sound = getCallSoundOption(localStorage.getItem(CALL_SOUND_STORAGE_KEY));
      this.audio.src = sound.src;
      this.audio.loop = true;
    },
    playCallAudio() {
      if (localStorage.getItem(CALL_SOUND_ENABLED_STORAGE_KEY) === 'false') {
        this.audio.pause();
        this.audio.currentTime = 0;
        return Promise.resolve(false);
      }
      this.initAudio();
      return this.audio.play().catch((error) => {
        console.warn("播放语音视频提示音失败:", error);
        return false;
      });
    },
    initRtc() {
      this.webrtc.init(this.configuration)
      this.webrtc.setupPeerConnection((stream) => {
        this.remoteStream = stream;
        this.$nextTick(() => {
          this.attachMediaStreamsToRefs();
        });
      })
      // 监听候选信息
      this.webrtc.onIcecandidate((candidate) => {
        if (this.state == "CHATING") {
          // 连接已就绪,直接发送
          this.API.sendCandidate(this.friend.id, candidate);
        } else {
          // 连接未就绪,缓存起来，连接后再发送
          this.localCandidates.push(candidate)
        }
      })
      // 监听连接成功状态
      this.webrtc.onStateChange((state) => {
        if (state == "connected") {
          console.log("webrtc连接成功")
        } else if (state == "disconnected") {
          console.log("webrtc连接断开")
        }
      })
    },
    onCall() {
      if (!this.checkDevEnable()) {
        this.close();
        return;
      }
      // 初始化webrtc
      this.initRtc();
      // 打开摄像头
      this.openStream().then(() => {
        this.webrtc.setStream(this.localStream);
        this.webrtc.createOffer().then((offer) => {
          this.startPrivateCallWithRetry(offer);
        })
      }).catch(() => {
        // 呼叫方必须能打开摄像头，否则无法正常建立连接
        this.close();
      })
    },
    startPrivateCallWithRetry(offer) {
      const timeoutMs = resolveCallStartRetryTimeoutMs(this.configStore);
      this.callStartRemainingSeconds = Math.ceil(timeoutMs / 1000);
      this.callStartController = createCallStartRetry(({ requestTimeoutMs }) => {
        return this.API.call(this.friend.id, this.mode, offer, this.clientCallId, {
          timeout: requestTimeoutMs,
          silent: true
        });
      }, {
        timeoutMs,
        onRetry: ({ remainingSeconds }) => {
          this.callStartVisible = true;
          this.callStartState = 'retrying';
          this.callStartRemainingSeconds = remainingSeconds;
          this.callStartDetail = '网络连接不稳定，正在重新连接通话服务';
        }
      });
      this.callStartController.promise.then(() => {
        this.callStartController = null;
        this.callStartVisible = false;
        if (this.state === 'CLOSE') {
          return;
        }
        this.state = "WAITING";
        this.startHeartBeat();
        this.playCallAudio();
      }).catch((error) => {
        this.callStartController = null;
        if (this.state !== 'CLOSE') {
          this.finishCallStartFailure(error);
        }
      });
    },
    cancelCallStartRetry() {
      if (this.callStartController) {
        this.callStartController.cancel();
      } else if (this.state !== 'CLOSE') {
        this.finishCallStartFailure({ cancelled: true });
      }
    },
    finishCallStartFailure() {
      this.callStartVisible = true;
      this.callStartState = 'cancelled';
      this.callStartRemainingSeconds = 0;
      this.callStartDetail = '未能连接到服务，本次通话已安全取消';
      // 请求可能已经到达服务端但响应丢失，尽力撤销同一会话。
      this.API.cancel(this.friend.id, this.clientCallId, { timeout: 3000, silent: true }).catch(() => {});
      if (this.callStartCloseTimer) {
        clearTimeout(this.callStartCloseTimer);
      }
      this.callStartCloseTimer = setTimeout(() => {
        this.callStartCloseTimer = null;
        this.close();
        this.callStartVisible = false;
      }, 1200);
    },
    resetCallStartView() {
      if (this.callStartCloseTimer) {
        clearTimeout(this.callStartCloseTimer);
        this.callStartCloseTimer = null;
      }
      this.callStartVisible = false;
      this.callStartState = 'retrying';
      this.callStartDetail = '';
      this.callStartRemainingSeconds = Math.ceil(resolveCallStartRetryTimeoutMs(this.configStore) / 1000);
    },
    onAccept() {
      if (!this.checkDevEnable()) {
        this.API.failed(this.friend.id, "对方设备不支持通话")
        this.close();
        return;
      }
      // 进入房间
      this.showRoom = true;
      this.showIncomingAcceptor = false;
      this.state = "CONNECTING";
      // 停止呼叫铃声
      this.audio.pause();
      // 初始化webrtc
      this.initRtc();
      // 打开摄像头
      this.openStream().then(() => {
        this.webrtc.setStream(this.localStream);
        this.webrtc.createAnswer(this.offer).then((answer) => {
          this.API.accept(this.friend.id, answer).then(() => {
            this.state = "CHATING";
            this.flushPendingRemoteCandidates().finally(() => {
              this.flushLocalCandidates();
            });
            // 记录时长
            this.startChatTime();
            // 清理定时器
            this.clearIncomingWaitTimer();
          }).catch(() => {
            this.$message.error("接听失败");
            this.close();
          });
        }).catch(() => {
          this.$message.error("创建应答失败");
          this.close();
        })
      }).catch(() => {
        this.API.failed(this.friend.id, "打开设备失败");
        this.close();
      })
    },
    onReject() {
      // 退出通话
      this.showIncomingAcceptor = false;
      this.API.reject(this.friend.id);
      // 退出
      this.close();
    },
    onHandup() {
      this.API.handup(this.friend.id)
      this.$message.success("您已挂断,通话结束")
      this.close();
    },
    onCancel() {
      this.API.cancel(this.friend.id, this.clientCallId)
      this.$message.success("已取消呼叫,通话结束")
      this.close();
    },
    onRTCMessage(msg) {
      // 除了发起通话，如果在关闭状态就无需处理
      if (msg.type != this.$enums.MESSAGE_TYPE.RTC_CALL_VOICE &&
        msg.type != this.$enums.MESSAGE_TYPE.RTC_CALL_VIDEO &&
        !(msg.type == this.$enums.MESSAGE_TYPE.RTC_CANDIDATE && this.offer) &&
        this.isClose) {
        return;
      }
      // RTC信令处理
      switch (msg.type) {
        case this.$enums.MESSAGE_TYPE.RTC_CALL_VOICE:
          this.onRTCCall(msg, 'voice')
          break;
        case this.$enums.MESSAGE_TYPE.RTC_CALL_VIDEO:
          this.onRTCCall(msg, 'video')
          break;
        case this.$enums.MESSAGE_TYPE.RTC_ACCEPT:
          this.onRTCAccept(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_REJECT:
          this.onRTCReject(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_CANCEL:
          this.onRTCCancel(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_FAILED:
          this.onRTCFailed(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_HANDUP:
          this.onRTCHandup(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_CANDIDATE:
          this.onRTCCandidate(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_RESTART_OFFER:
          this.onRTCRestartOffer(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_RESTART_ANSWER:
          this.onRTCRestartAnswer(msg)
          break;
        case this.$enums.MESSAGE_TYPE.RTC_NETWORK_END:
          this.onRTCNetworkEnd()
          break;
      }
    },
    onRTCCall(msg, mode) {
      try {
        this.offer = JSON.parse(msg.content);
      } catch (error) {
        console.error("解析RTC offer失败:", error, msg);
        return;
      }
      this.isHost = false;
      this.mode = mode;
      this.state = "WAITING";
      this.showIncomingAcceptor = true;
      this.friend = this.buildIncomingFriend(msg);
      this.playCallAudio();
      this.startHeartBeat();
      // 页面真正展示来电后确认响铃，后端从此刻给足完整接听时间。
      if (msg.inviteSlot && msg.callId) {
        this.API.ringing(msg.inviteSlot, msg.callId).then((ringingData) => {
          if (ringingData && ringingData.active === false) {
            this.close();
            return;
          }
          this.startIncomingWaitTimer(msg, ringingData);
        }).catch((error) => {
          console.warn("上报 Web 来电响铃失败，使用消息截止时间:", error);
          this.startIncomingWaitTimer(msg);
        });
      } else {
        this.startIncomingWaitTimer(msg);
      }
      this.$http({
        url: `/friend/find/${msg.sendId}`,
        method: 'get'
      }).then((friend) => {
        this.friend = friend;
      }).catch((error) => {
        console.warn("加载来电好友资料失败，继续使用本地兜底资料:", error);
      });
    },
    onRTCAccept(msg) {
      if (msg.selfSend) {
        // 在其他设备接听
        this.$message.success("已在其他设备接听");
        this.close();
      } else {

        // 对方接受了的通话
        let answer = JSON.parse(msg.content);
        console.log("收到answer:", answer)
        this.webrtc.setRemoteDescription(answer).then(() => {
          console.log("远程描述（answer）设置成功");
        // 状态为聊天中
        this.state = 'CHATING'
        // 停止播放语音
        this.audio.pause();
        // 发送candidate
        this.flushLocalCandidates();
        this.flushPendingRemoteCandidates();
        // 开始计时
        this.startChatTime()
        }).catch((error) => {
          console.error("设置远程描述（answer）失败:", error);
        });
      }
    },
    onRTCReject(msg) {
      if (msg.selfSend) {
        this.$message.success("已在其他设备拒绝");
        this.close();
      } else {
        this.$message.error("对方拒绝了您的通话请求");
        this.close();
      }
    },
    onRTCFailed(msg) {
      // 呼叫失败
      this.$message.error(msg.content)
      this.close();
    },
    onRTCCancel() {
      // 对方取消通话
      this.$message.success("对方取消了呼叫");
      this.close();
    },
    onRTCHandup() {
      // 对方挂断
      this.$message.success("对方已挂断");
      this.close();
    },
    onRTCCandidate(msg) {
      let candidate = JSON.parse(msg.content);
      if (!this.webrtc.peerConnection || !this.webrtc.peerConnection.remoteDescription) {
        this.pendingRemoteCandidates.push(candidate);
        return;
      }
      this.webrtc.addIceCandidate(candidate).then(() => {
        console.log("ICE候选添加成功");
      }).catch((error) => {
        console.error("ICE候选添加失败:", error);
      });
    },
    shouldRollbackPrivateOffer(fromUserId) {
      const localId = Number(this.userStore.userInfo.id);
      const remoteId = Number(fromUserId);
      if (Number.isFinite(localId) && Number.isFinite(remoteId) && localId !== remoteId) {
        return localId > remoteId;
      }
      return String(this.userStore.userInfo.id) > String(fromUserId);
    },
    async onRTCRestartOffer(msg) {
      const peerConnection = this.webrtc.peerConnection;
      if (!peerConnection || this.state !== 'CHATING') {
        return;
      }
      try {
        if (peerConnection.signalingState === 'have-local-offer') {
          if (!this.shouldRollbackPrivateOffer(msg.sendId)) {
            console.warn('本端ICE重连Offer优先，忽略同时到达的远端Offer');
            return;
          }
          await peerConnection.setLocalDescription({ type: 'rollback' });
        }
        if (peerConnection.signalingState !== 'stable') {
          console.warn(`当前信令状态为 ${peerConnection.signalingState}，忽略ICE重连Offer`);
          return;
        }
        const restartOffer = typeof msg.content === 'string' ? JSON.parse(msg.content) : msg.content;
        await this.webrtc.setRemoteDescription(restartOffer);
        await this.flushPendingRemoteCandidates();
        const restartAnswer = await this.webrtc.createAnswer();
        await this.API.restartAnswer(this.friend.id, restartAnswer);
        console.log('Web端已应答ICE重连Offer');
      } catch (error) {
        console.warn('Web端处理ICE重连Offer失败:', error);
      }
    },
    async onRTCRestartAnswer(msg) {
      const peerConnection = this.webrtc.peerConnection;
      if (!peerConnection || this.state !== 'CHATING' || peerConnection.signalingState !== 'have-local-offer') {
        return;
      }
      try {
        const restartAnswer = typeof msg.content === 'string' ? JSON.parse(msg.content) : msg.content;
        await this.webrtc.setRemoteDescription(restartAnswer);
        await this.flushPendingRemoteCandidates();
        console.log('Web端ICE重连完成');
      } catch (error) {
        console.warn('Web端处理ICE重连Answer失败:', error);
      }
    },
    onRTCNetworkEnd() {
      this.$message.error('网络异常，通话中断');
      this.close();
    },

    openStream() {
      return new Promise((resolve, reject) => {
        if (this.isVideo) {
          // 打开摄像头+麦克风
          this.camera.openVideo().then((stream) => {
            this.localStream = stream;
            this.$nextTick(() => {
              this.attachMediaStreamsToRefs();
            })
            resolve(stream);
          }).catch((e) => {
            this.$message.error("打开摄像头失败")
            console.log("本摄像头打开失败:" + e.message)
            reject(e);
          })
        } else {
          // 打开麦克风
          this.camera.openAudio().then((stream) => {
            this.localStream = stream;
            this.$nextTick(() => {
              this.attachMediaStreamsToRefs();
            });
            resolve(stream);
          }).catch((e) => {
            this.$message.error("打开麦克风失败")
            console.log("打开麦克风失败:" + e.message)
            reject(e);
          })
        }
      })
    },
    startChatTime() {
      this.videoTime = 0;
      this.videoTimer && clearInterval(this.videoTimer);
      this.videoTimer = setInterval(() => {
        this.videoTime++;
      }, 1000)
    },
    checkDevEnable() {
      // 检测摄像头
      if (!this.camera.isEnable()) {
        this.$message.error("访问摄像头失败");
        return false;
      }
      // 检测webrtc
      if (!this.webrtc.isEnable()) {
        this.$message.error("初始化RTC失败，原因可能是: 1.服务器缺少ssl证书 2.您的设备不支持WebRTC");
        return false;
      }
      return true;
    },
    startHeartBeat() {
      // 与服务端30秒失联判定保持足够余量：立即发送，之后每10秒一次。
      this.heartbeatTimer && clearInterval(this.heartbeatTimer);
      const sendHeartbeat = () => {
        if (!this.friend.id || this.state === 'CLOSE') {
          return;
        }
        this.API.heartbeat(this.friend.id).catch((error) => {
          console.warn('Web单聊通话心跳失败:', error);
        });
      };
      sendHeartbeat();
      this.heartbeatTimer = setInterval(() => {
        sendHeartbeat();
      }, 10000)
    },
    close() {
      if (this.callStartController) {
        const controller = this.callStartController;
        this.callStartController = null;
        controller.cancel();
      }
      this.clearShowRoomTimer();
      this.showRoom = false;
      this.showIncomingAcceptor = false;
      this.camera.close();
      this.webrtc.close();
      this.audio.pause();
      this.offer = null;
      this.videoTime = 0;
      this.videoTimer && clearInterval(this.videoTimer);
      this.heartbeatTimer && clearInterval(this.heartbeatTimer);
      this.clearIncomingWaitTimer();
      if (this.localStream) {
        this.localStream.getTracks().forEach(track => track.stop());
        this.localStream = null;
      }
      if (this.remoteStream) {
        this.remoteStream.getTracks().forEach(track => track.stop());
        this.remoteStream = null;
      }
      if (this.$refs.localVideo) {
        this.$refs.localVideo.srcObject = null;
      }
      if (this.$refs.remoteVideo) {
        this.$refs.remoteVideo.srcObject = null;
      }
      this.videoTimer = null;
      this.heartbeatTimer = null;
      this.state = 'CLOSE';
      this.localCandidates = [];
      this.pendingRemoteCandidates = [];
    },
    onQuit() {
      if (this.callStartController) {
        this.cancelCallStartRetry();
        return;
      }
      if (this.isChating) {
        this.onHandup()
      } else if (this.isWaiting) {
        this.onCancel();
      } else {
        this.close();
      }
    }
  },
  computed: {
    width() {
      return this.isVideo ? '960px' : '360px'
    },
    title() {
      let strTitle = `${this.modeText}通话-${this.friend.nickName}`;
      if (this.isChating) {
        strTitle += `(${this.currentTime})`;
      } else if (this.isWaiting) {
        strTitle += `(呼叫中)`;
      }
      return strTitle;
    },
    currentTime() {
      let min = Math.floor(this.videoTime / 60);
      let sec = this.videoTime % 60;
      let strTime = min < 10 ? "0" : "";
      strTime += min;
      strTime += ":"
      strTime += sec < 10 ? "0" : "";
      strTime += sec;
      return strTime;
    },
    configuration() {
      const iceServers = this.configStore.webrtc.iceServers;
      return {
        iceServers: iceServers
      }
    },
    isVideo() {
      return this.mode == "video"
    },
    modeText() {
      return this.isVideo ? "视频" : "语音";
    },
    isChating() {
      return this.state == "CHATING";
    },
    isWaiting() {
      return this.state == "WAITING";
    },
    isClose() {
      return this.state == "CLOSE";
    }
  },
  mounted() {
    // 初始化音频文件
    this.initAudio();
  },
  created() {
    // 监听页面刷新事件
    this.beforeUnloadHandler = () => {
      this.onQuit();
    };
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },
  beforeUnmount() {
    if (this.beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
      this.beforeUnloadHandler = null;
    }
    this.onQuit();
  }
}
</script>

<style lang="scss" scoped>
.rtc-private-video {
  position: relative;

  .el-loading-text {
    color: white !important;
    font-size: 16px !important;
  }

  .path {
    stroke: white !important;
  }

  .rtc-video-box {
    position: relative;
    background-color: #eeeeee;

    .rtc-video-friend {
      height: 70vh;

      .friend-head-image {
        position: absolute;
      }

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transform: rotateY(180deg);
      }
    }

    .rtc-video-mine {
      position: absolute;
      z-index: 99999;
      width: 25vh;
      right: 0;
      bottom: -1px;

      video {
        width: 100%;
        object-fit: cover;
        transform: rotateY(180deg);
      }
    }
  }

  .rtc-voice-box {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 300px;
    background-color: var(--im-color-primary-light-9);

    .rtc-voice-name {
      text-align: center;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .rtc-control-bar {
    display: flex;
    justify-content: space-around;
    padding: 10px;

    .icon {
      font-size: 50px;
      cursor: pointer;
    }
  }
}
</style>
